import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';

function productImpressionModalInsurance({
  currency,
  fareTypes,
  itinerary,
  market,
  options,
  tripType,
}) {
  const obj = {
    'event': 'productImpression',
    'ecommerce': {
      'actionField' : { 'list' : 'Insurance Modal' },
      'currencyCode' : currency,
      'impressions': [],
    },
  };
  const impressions = obj.ecommerce.impressions;
  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = getFareFamily(fareTypes);
  options.forEach((option, i) => {
    const impression = {
      name: getAncillaryNameInsurance(option.ancillary.type),
      id: option.ancillary.type,
      price: option.ancillary.currency.base,
      brand: 'Aeromexico',
      category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
      variant: '',
      position: i + 1,
      tax: option.ancillary.currency.totalTax,
    };

    impressions.push(impression);
  });

  try {
    let pnrData = window.currentPNR;
    
    if (!pnrData) {
      try {
        pnrData = JSON.parse(localStorage.getItem('currentPNR') || '{}');
      } catch (e) {
        // Error
      }
    }
    
    let userEmail = 'insurance-view@aeromexico.com';
    let pnrCode = 'INSURANCE_MODAL';
    
    if (pnrData) {
      userEmail = pnrData.passengers?.[0]?.email || 
                 pnrData.passengers?.[0]?.contactEmail ||
                 pnrData.email ||
                 pnrData.contactInformation?.email ||
                 userEmail;
      pnrCode = pnrData.pnrCode || pnrData.pnr || pnrCode;
    }

    const realPnrInfo = {
      pnrCode: pnrCode,
      email: userEmail,
      firstName: pnrData?.passengers?.[0]?.firstName || 'Guest',
      lastName: pnrData?.passengers?.[0]?.lastName || 'User',
      flightItineraryType: tripType,
      cart: pnrData?.cart || { travelerCollection: [] },
      legCollection: pnrData?.legCollection || [],
    };

    sendAncillaryEventToCustomerIO('travelinsurance', obj, realPnrInfo);
  } catch (error) {
    // Error
  }

  return obj;
}

function addToCartModalInsurance({
  currency,
  countAncillary,
  fareTypes,
  itinerary,
  market,
  options,
  tripType,
}) {
  const obj = {
    'event': 'addToCart',
    'ecommerce': {
      'currencyCode' : currency,
      'add': {
        'products': [],
      },
    },
  };
  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = getFareFamily(fareTypes);
  const products = obj.ecommerce.add.products;

  options.forEach((option, i) => {
    const type = option.type ? option.type : option.ancillary.type;
    if (option.quantity !== 0 && type !== 'AMS') {
      const impression = {
        id: type,
        name: getAncillaryNameInsurance(type),
        price: option.ancillary.currency.base,
        brand: 'Aeromexico',
        category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
        variant: '',
        position: i + 1,
        tax: option.ancillary.currency.totalTax,
        quantity: countAncillary,
      };
      products.push(impression);
    }
  });

  return obj;
}

function removeToCartModalInsurance({
  currency,
  fareTypes,
  itinerary,
  market,
  options,
  tripType,
}) {
  const obj = {
    'event': 'removeFromCart',
    'ecommerce': {
      'currencyCode' : currency,
      'remove': {
        'products': [],
      },
    },
  };

  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = fareTypes[0];
  const products = obj.ecommerce.remove.products;
  options.forEach((option, i) => {
    const type = option.ancillary.type;
    if (option.quantity === 0 && type !== 'AMS') {
      const impression = {
        id: type,
        name: getAncillaryNameInsurance(type),
        price: option.ancillary.currency.base,
        brand: 'Aeromexico',
        category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
        variant: '',
        position: i + 1,
        tax: option.ancillary.currency.totalTax,
      };
      products.push(impression);
    }
  });

  return obj;
}

function productClickModalInsurance({
  fareTypes,
  itinerary,
  market,
  options,
  tripType,
}) {
  const obj = {
    'event': 'productClick',
    'ecommerce': {
      'click': {
        'actionField': { 'list': 'Cart Review', 'step': 5, 'action': 'click' },
        'products': [],
      },
    },
  };
  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = getFareFamily(fareTypes);
  const products = obj.ecommerce.click.products;

  options.forEach((option, i) => {
    const type = option.ancillary.type;
    if (type !== 'AMS') {
      const impression = {
        id: type,
        name: getAncillaryNameInsurance(type),
        price: option.ancillary.currency.base,
        brand: 'Aeromexico',
        category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
        variant: 'NA',
        position: i + 1,
        tax: option.ancillary.currency.totalTax,
      };
      products.push(impression);
    }
  });

  return obj;
}

function checkoutModalInsurance({
  currency,
  departureRoute,
  departureTime,
  fareTypes,
  itinerary,
  market,
  options,
  storefront,
  tripType,
}) {
  const obj = {
    'event': 'checkout',
    'returnFlightAvailable': false,
    'storeFront': storefront,
    'departureRoute': departureRoute,
    'departureTime': departureTime,
    'passengerStatus': 'check-in',
    'transactionType': 'Web Check in',
    'ecommerce': {
      'currencyCode': currency,
      'checkout': {
        'actionField': { 'step': 1, 'action': 'checkout' },
        'products': [],
      },
    },
  };
  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = getFareFamily(fareTypes);
  const products = obj.ecommerce.checkout.products;

  options.forEach((option, i) => {
    const type = option.ancillary.type;
    if (type !== 'AMS') {
      const impression = {
        id: type,
        name: getAncillaryNameInsurance(type),
        price: option.ancillary.currency.base,
        brand: 'Aeromexico',
        category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
        variant: 'NA',
        position: i + 1,
        tax: option.ancillary.currency.totalTax,
        list: 'Checkin Payment',
      };
      products.push(impression);
    }
  });

  return obj;
}

function purchaseModalInsurance({
  affiliation,
  currency,
  departureRoute,
  departureTime,
  fareTypes,
  id,
  itinerary,
  market,
  options,
  purchasePlace,
  returnFlightAvailable,
  revenue,
  storefront,
  tax,
  tripType,
}) {
  const obj = {
    'event': 'purchase',
    'purchasePlace': purchasePlace,
    'returnFlightAvailable': returnFlightAvailable,
    'storeFront': storefront,
    'departureRoute': departureRoute,
    'departureTime': departureTime,
    'passengerStatus': 'check in',
    'FlujoChannel': 'Checkin',
    'ecommerce': {
      'currencyCode': currency,
      'purchase': {
        'actionField': {
          'id': id,
          'affiliation': affiliation,
          'revenue': revenue,
          'tax': tax,
          'action': 'purchase',
        },
        'products': [],
      },
    },
  };
  const flightTypeCode = getCodeFlightType(tripType);
  const marketCode = marketFlightInitials(market);
  const fareType = getFareFamily(fareTypes);
  const products = obj.ecommerce.purchase.products;

  options.forEach((option) => {
    const type = option.ancillary.type;
    if (type !== 'AMS') {
      const impression = {
        id: type,
        name: getAncillaryNameInsurance(type),
        price: option.ancillary.currency.base,
        brand: 'Aeromexico',
        category: `Misc/Ancillary/${itinerary}/${fareType}/${flightTypeCode}-${marketCode}`,
        variant: 'NA',
        list: 'Check-in Purchase Confirmation',
      };
      products.push(impression);
    }
  });

  // Customer.io Integration for Insurance Purchase
  try {
    let pnrData = window.currentPNR;
    const realPnrCode = id;

    if (!pnrData && realPnrCode) {
      try {
        pnrData = JSON.parse(localStorage.getItem('currentPNR') || '{}');
      } catch (e) {
        // Silent catch
      }
    }
    
    let userEmail = 'insurance-purchase@aeromexico.com'; // Fallback for insurance
    if (pnrData) {
      userEmail = pnrData.passengers?.[0]?.email || 
                 pnrData.passengers?.[0]?.contactEmail ||
                 pnrData.email ||
                 pnrData.contactInformation?.email ||
                 userEmail;
    }

    const realPnrInfo = {
      pnrCode: realPnrCode,
      email: userEmail,
      firstName: pnrData?.passengers?.[0]?.firstName || 'Guest',
      lastName: pnrData?.passengers?.[0]?.lastName || 'User',
      flightItineraryType: tripType,
      cart: pnrData?.cart || { travelerCollection: [] },
      legCollection: pnrData?.legCollection || [],
    };

    sendAncillaryEventToCustomerIO('travelinsurance', obj, realPnrInfo);
  } catch (error) {
    // Error
  }

  return obj;
}


function getCodeFlightType(flightType) {
  return flightType ? flightType === 'ROUNDTRIP' ? 'RT' : flightType === 'ONEWAY' ? 'OW' : 'MC' : 'NA';
}

function getAncillaryNameInsurance(insurance) {
  let newName = null;
  switch (insurance) {
    case 'SXC': newName = 'Cancellation Insurance'; break;
    case 'SXP': newName = 'Cancellation Insurance PLUS'; break;
    case 'SDE': newName = 'Luggage Insurance'; break;
    case 'SEP': newName = 'Luggage Insurance PLUS'; break;
    default: newName = null;
  }

  return newName;
}

function marketFlightInitials(marketFlight) {
  if (marketFlight === 'DOMESTIC' || marketFlight === 'Domestic') {
    marketFlight = 'Domestic';
  } else if (marketFlight === 'TRANSBORDER' || marketFlight === 'Transborder') {
    marketFlight = 'Transborder';
  } else if (marketFlight === 'SUDAMERICA_ASIA' || marketFlight === 'Sudamerica_asia') {
    marketFlight = 'AyS';
  } else if (marketFlight === 'EUROPA' || marketFlight === 'Europa') {
    marketFlight = 'Europe';
  } else if (marketFlight === 'CENTROAMERICA_CARIBE' || marketFlight === 'Centroamerica_caribe') {
    marketFlight = 'CyC';
  }

  return marketFlight;
}

function getFareFamily(fareFamily) {
  switch ( fareFamily ) {
    case 'CLASSIC':
      return 'COACH_CL';
    case 'CLASSIC_FLEXIBLE':
      return 'COACH_CF';
    case 'FLEXIBLE':
      return 'COACH_FL';
    case 'AMPLUS':
      return 'COACH_AM';
    case 'AMPLUS_FLEXIBLE':
      return 'COACH_AF';
    case 'COMFORT':
      return 'FIRST_CL';
    case 'PREMIER':
      return 'FIRST_FL';
    case 'PREMIER_FLEXIBLE':
      return 'FIRST_FF';
    case 'PREMIER_ONE':
      return 'FIRST_PO';
    case 'PREMIER_ONE_FLEXIBLE':
      return 'FIRST_PF';
    default:
      return '';
  }
}


export default {
  addToCartModalInsurance,
  checkoutModalInsurance,
  productClickModalInsurance,
  productImpressionModalInsurance,
  purchaseModalInsurance,
  removeToCartModalInsurance,
};